import type { SearchableOption } from "./types";

const LABEL_CLASS = "searchable-select-label";
const DESC_CLASS = "searchable-select-desc";

export function renderOption(option: SearchableOption, id: string): HTMLAnchorElement {
  const element = document.createElement("a");
  element.className = "dropdown-item";
  element.setAttribute("role", "option");
  element.id = id;
  element.dataset.value = option.value;

  const label = document.createElement("span");
  label.className = LABEL_CLASS;
  label.textContent = option.label;
  element.append(label);

  if (option.desc !== undefined && option.desc !== "") {
    const desc = document.createElement("span");
    desc.className = DESC_CLASS;
    desc.textContent = option.desc;
    element.append(desc);
  }

  return element;
}

export function parseOptionElement(element: HTMLElement): SearchableOption {
  const label = element.querySelector(`.${LABEL_CLASS}`)?.textContent ?? element.textContent ?? "";
  const desc = element.querySelector(`.${DESC_CLASS}`)?.textContent;

  return {
    value: element.dataset.value ?? "",
    label: label.trim(),
    ...(desc ? { desc: desc.trim() } : {}),
  };
}
